import Emitter from "./Emitter";

export default class GameChange extends Emitter{
    constructor(gb) {
        super(gb);
    }

    PLAYTECH_handler(data){
        debugger
        const leaderboardData = {
            _type: "ucip.gamechange.g2wGameChangeNotification",
            gameCode: data.gameCode
        }

        this.emitTop(JSON.stringify(leaderboardData))
        window.parent.postMessage(JSON.stringify(leaderboardData));
    }

    _default() {
        return
    }

}